import { render } from "./Info-card.component.vue?vue&type=template&id=745271d9&ts=true"
import script from "./Info-card.component.vue?vue&type=script&lang=ts"
export * from "./Info-card.component.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__